export class UsoVehiculoModel {

  id: number;
  nombre: string;

  constructor() {
    this.id = null;
    this.nombre = '';
  }
}
